import React, {Component} from 'react';
import ReportContainer from "../../containers/report_container";
import {Button, Form, Input, Segment} from "semantic-ui-react";
import { DropzoneComponent } from 'react-dropzone-component';

const uuidv1 = require('uuid/v1');

class AddNewReading extends Component {
    constructor(props) {
        super(props);
        this.state = {
            readingValue: undefined,
            readingImage: undefined,
        }
    }

    handleSubmit = () => {
        this.setState({isCreating:true});
        let newReading = {
            meter_id: this.props.meterId,
            client_id: uuidv1(),
            action: 'create'
        };
        if (this.props.reportDetails['inspection_type'] === 'co') {
            newReading['co_value'] = this.state.readingValue;
            newReading['co_image'] = this.state.readingImage;
        }
        else {
            newReading['ci_value'] = this.state.readingValue;
            newReading['ci_image'] = this.state.readingImage;
        }
        this.props.addNewReadingToMeter(newReading,this.props.meterIndex);
        this.refs.readingRef.inputRef.value = '';
        // this.refs.addImage.inputRef.value = null;
        this.setState({isCreating:false});
    };
    
    removingFile = () => {
        this.setState({readingImage: undefined});
    };

    updateReadingImage = (file) => {
        let fr = new FileReader();
        if (file) {
            fr.onload = (e) => {
                file['dataURL'] = e.target.result;
                const image = {
                    id: uuidv1(),
                    file: file,
                };
                this.setState({readingImage: image});
            };
            fr.readAsDataURL(file);
        }
    };

    render() {
        
        let dropZone = null;
        const componentConfig = {postUrl: 'no-url'};

        let djsConfig = {
            autoProcessQueue: false,
            addRemoveLinks: true,
            acceptedFiles: "image/jpeg, image/png, image/gif",
            maxFiles: 1
        };
        const eventHandlers = {
            init: (dropzone) => {
                dropZone = dropzone;
                dropZone.autoDiscover = false;
            },
            addedfile: (file) => {
                    this.removingFile(file)  
                    if(file.type.startsWith("image/")){
                        this.updateReadingImage(file)
                        this.setState({imageError:false})
                    }
                    else {
                        this.setState({imageError:true})
                    }
            },
            maxfilesexceeded: function (files) {
                this.removeAllFiles();
                this.addFile(files);
         },

            removedfile: (file) => {
                this.removingFile(file)                   
            },
            // complete: function(file) {
            //       this.removeFile(file); // right here after 3 seconds you can clear
            //   },
        };
        
        return (<Segment style={{margin:"auto",width: '80%'}}>
            <Form onSubmit={this.handleSubmit}>
                <Form.Field>
                    <label>Meter Reading</label>
                    <Input
                        placeholder="Eg. A8747 day"
                        ref="readingRef"
                        required
                        onChange={(e) => {
                            this.setState({readingValue: e.target.value})
                        }}
                    />
                </Form.Field>
                <Form.Field>
                    <label>Image of Reading</label>
                    <DropzoneComponent config={componentConfig} style={{ minHeight: 250 }}
                eventHandlers={eventHandlers} djsConfig={djsConfig}/>
                    {/* <Input
                        type="file"
                        required
                        accept="image/*"
                        ref="addImage"
                        onChange={(e) => {
                            this.updateReadingImage(e.target.files[0])
                        }}
                    /> */}
                </Form.Field>
                <Button primary content="Add New Reading" disabled={this.state.isCreating}/>
            </Form>
        </Segment>);
    }
}

export default ReportContainer(AddNewReading);


// WEBPACK FOOTER //
// ./src/views/report/add_new_reading.js